import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import styles from './ExistingDeclarationModal.scss';

const ExistingDeclarationModal = ({ isOpen, periodType, year, periodMonth, periodQuarter, onCancel, onConfirm }) => {
  const { t, i18n } = useTranslation();

  const buildMessage = () => {
    if (!year) return '';
    if (periodType === 'monthly' && periodMonth) {
      moment.locale(i18n.language);
      const monthName = moment(periodMonth, 'M').format('MMMM');
      return t('features.ReportIncomeTax.create.existing_modal.message_monthly', { month: monthName, year });
    }
    if (periodType === 'quarterly' && periodQuarter) {
      return t('features.ReportIncomeTax.create.existing_modal.message_quarterly', { quarter: periodQuarter, year });
    }
    return '';
  };

  const header = t('features.ReportIncomeTax.create.existing_modal.title');
  const body = buildMessage();

  return (
    <CommonModal header={header} isOpen={isOpen} hideModal={onCancel} ariaHideApp={false} className={styles.existingDeclarationModal}>
      <CommonModal.Header hideModal={onCancel}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <div className={styles.existingDeclarationModalBody}>{body}</div>
      </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons className={styles.modalButtons}>
          <Button onClick={onCancel}>{t('features.ReportIncomeTax.create.existing_modal.cancel')}</Button>
          <Button onClick={onConfirm} primary>
            {t('features.ReportIncomeTax.create.existing_modal.confirm')}
          </Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  );
};

ExistingDeclarationModal.propTypes = {
  isOpen: PropTypes.bool,
  periodType: PropTypes.string,
  year: PropTypes.number,
  periodMonth: PropTypes.number,
  periodQuarter: PropTypes.number,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

ExistingDeclarationModal.defaultProps = {
  isOpen: false,
  periodType: 'monthly',
  year: null,
  periodMonth: null,
  periodQuarter: null
};

export default ExistingDeclarationModal;
